import getTrackingJSON from './ProcessJsonTracking';
import { ETrackingEventsName, UnionTrackingEventsData } from '../../models/Tracking.interfaces';
import { isWebviewAndroid, isWebviewIOS } from './controlDevices';

function sendAnalyticsToNative(type: ETrackingEventsName, data: UnionTrackingEventsData) {
    const jsonTracking: any = getTrackingJSON(type, data);
    if (isWebviewAndroid) {
        window.Android?.getFromAndroid(jsonTracking);
    }
    if (isWebviewIOS) {
        window.webkit?.messageHandlers.jsMessageHandler.postMessage(jsonTracking);
    }
    return true;
}

export default sendAnalyticsToNative;
